import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Controller } from 'react-hook-form';
import { phoneFormat, removePhoneFormat } from '../../utils/utils';
const PhoneInput = ({ control, name, label, className, }) => {
    const id = useId();
    return (_jsx(Controller, { control: control, name: name, render: ({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => {
            return (_jsxs("div", { className: `control-group ${className} ${invalid && 'error'}`, children: [_jsx("label", { htmlFor: id, children: label }), _jsxs("div", { className: "phone-input-wrapper", children: [_jsx("input", { ...field, id: id, type: "text", inputMode: "numeric", className: "phone-input", placeholder: "( ___ ) ___-____", value: phoneFormat(value), onChange: (e) => {
                                    const textWithoutFormat = removePhoneFormat(e.target.value);
                                    const onlyNums = textWithoutFormat.replace(/[^0-9]/g, '');
                                    onChange(onlyNums);
                                } }), _jsx("span", { className: "phone-input-decorator", children: "+1" })] }), error?.message && _jsx("p", { className: "error-message", children: error.message })] }));
        } }));
};
export default PhoneInput;
